import { useEffect, useState } from "react";
import Logo from '../assets/images/Logo.png';
import AuthService from "../services/auth.service";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../components/loader";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../app/store";
import { showToast } from "../app/slice/toastsSlice";

function Reciept() {
    const params = useParams();
    const [isPageloading, setIsPageLoading] = useState(true);
    const [txnDetails, setTxnDetails] = useState<any>([]);
    const [message, setMessage] = useState("");
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    
    useEffect(() => {
        let formData = {
            table_row_id: params.id
        }
        AuthService.statementsDetails(formData)
            .then(
                (response) => {
                    // console.log(response.data);
                    if (response.status === 200) {
                        setTxnDetails(response?.data);

                    } else {
                        setMessage(response?.message);
                    }

                }
            ).catch((error) => {
                //console.log(error?.status, error?.response?.data?.status)
                const message = error?.response?.data?.error_description;
                setMessage(message);
                if (error?.response?.data?.status === 401) {
                    localStorage.removeItem("w_token");
                    navigate('/login');
                }
            }).finally(() => {
                setIsPageLoading(false);
            });
        // eslint-disable-next-line
    }, []);

    const handleCopy = async () => {
        const inputValue = document.getElementById("txn_id") as HTMLInputElement;

        if ("clipboard" in navigator) {
            await navigator.clipboard.writeText(inputValue.innerText);
        } else {
            const el = document.createElement('input');
            el.value = inputValue.innerText;
            document.body.appendChild(el);
            el.select();
            el.setSelectionRange(0, 99999);
            document.execCommand('copy');
            document.body.removeChild(el);
        }
        let toast = {
            type: 'success',
            title: 'Copied!',
            //message: 'Copied'
        }
        dispatch(showToast(toast));
    };

    return (
        <>
            {isPageloading && <Loader />}
            <section className="recieptMain">
                <div className="container">
                    <div className="row " id="reciept-container">
                        <div className="col-12">
                            <div className="cashedOutCard">
                                <div className='logoRecipt'>
                                    <img src={Logo} alt="Logo" className='img-fluid' />
                                </div>
                                <div className="d-flex justify-content-between align-items-end">
                                    {/* <p className="text-white">{txnDetails?.main_heading}</p> */}
                                    <span>
                                        <h1>₹{txnDetails?.amount}</h1>
                                        {/* <p className="cass">Cashed Out</p> */}
                                    </span>
                                    {txnDetails?.statement_flag === 'Win' && <h4 className="win">({(txnDetails?.winning_amount/txnDetails?.amount).toFixed(1)}X Winning)</h4>}
                                </div>
                                <div className="d-flex align-items-center" style={{ marginTop: 48 }}>
                                    <h6 className="id">ID : <span style={{ fontWeight: 700 }} id="txn_id">{txnDetails?.txn_id}</span></h6>
                                  
                                    <button className="share">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect width="24" height="24" rx="4" fill="white" fillOpacity="0.2" />
                                            <path d="M15.8265 13.5761L14.7016 12.4512L15.8265 11.3264C17.069 10.0838 17.069 8.06932 15.8265 6.82681C14.584 5.5843 12.5695 5.5843 11.3269 6.82681L10.2021 7.9517L9.07718 6.82681L10.2021 5.70192C12.0658 3.83815 15.0876 3.83815 16.9514 5.70192C18.8151 7.5657 18.8151 10.5875 16.9514 12.4512L15.8265 13.5761ZM13.5767 15.8259L12.4518 16.9508C10.5881 18.8145 7.56629 18.8145 5.70252 16.9508C3.83874 15.087 3.83874 12.0652 5.70252 10.2015L6.8274 9.07658L7.95229 10.2015L6.8274 11.3264C5.58489 12.5689 5.58489 14.5834 6.8274 15.8259C8.06992 17.0684 10.0844 17.0684 11.3269 15.8259L12.4518 14.701L13.5767 15.8259ZM13.5767 7.9517L14.7016 9.07658L9.07718 14.701L7.95229 13.5761L13.5767 7.9517Z" fill="white" />
                                        </svg>
                                    </button>
                                    <button className="share" onClick={handleCopy}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="24" height="24" rx="4" fill="white" fillOpacity="0.1" />
                                            <path d="M8.92397 7.98417V6.14413C8.92397 5.80539 9.19858 5.53078 9.53732 5.53078H16.8975C17.2362 5.53078 17.5108 5.80539 17.5108 6.14413V14.731C17.5108 15.0697 17.2362 15.3443 16.8975 15.3443H15.0574V17.1838C15.0574 17.5229 14.7815 17.7977 14.4399 17.7977H7.08813C6.74707 17.7977 6.4707 17.525 6.4707 17.1838L6.4723 8.59805C6.47236 8.25902 6.74833 7.98417 7.08983 7.98417H8.92397ZM10.1507 7.98417H15.0574V14.1176H16.2841V6.75748H10.1507V7.98417Z" fill="white" />
                                        </svg>
                                    </button>
                                </div>
                                <p className="placeBet">{txnDetails?.created_at}</p>
                            </div>
                        </div>
                        <div className="col-12 mt-2">
                            <div className="cashedOutCard SuccessfulCard oddsCard pb-0">
                                <div className="d-flex justify-content-between">
                                    <span>
                                        <h1>
                                            <svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                                <path d="M15.8014 3.66667C18.839 3.66667 21.3014 6.1291 21.3014 9.16667V12.8333C21.3014 15.8709 18.839 18.3333 15.8014 18.3333H6.63477C3.5972 18.3333 1.13477 15.8709 1.13477 12.8333V9.16667C1.13477 6.1291 3.5972 3.66667 6.63477 3.66667H15.8014ZM9.38477 8.25H7.55143V10.0833H5.7181V11.9167H7.55052L7.55143 13.75H9.38477L9.38385 11.9167H11.2181V10.0833H9.38477V8.25ZM16.7181 11.9167H14.8848V13.75H16.7181V11.9167ZM14.8848 8.25H13.0514V10.0833H14.8848V8.25Z" fill="white" />
                                            </svg>
                                            {txnDetails?.match_title}
                                        </h1>
                                    </span>
                                    <h4 className={`win ${txnDetails?.txn_type==='Credit' ? '' : 'loss'}`}>
                                        {txnDetails?.txn_type}
                                    </h4>
                                </div>
                                <div className="betQestion">
                                    <p className="m-0">
                                        {txnDetails?.match_title},
                                        &nbsp;{txnDetails?.title},
                                        <span className="text-capitalize">&nbsp;{txnDetails?.bet_type?.replace(/[^a-zA-Z ]/g, " ")}, 
                                        &nbsp;{txnDetails?.selection_type}</span>
                                    </p>
                                </div>
                                <ul>
                                    <li>
                                        <h4>Odds</h4>
                                        <h4 className="odsnu">{txnDetails?.bet_type === 'fancy' || txnDetails?.bet_type === 'meter' || txnDetails?.bet_type === 'overbyover' ? txnDetails?.size : txnDetails?.price}</h4>
                                    </li>
                                    <li>
                                        <h4>Total Bet</h4>
                                        <h4>₹ {txnDetails?.amount}</h4>
                                    </li>
                                    {txnDetails?.statement_flag === 'Win' &&
                                        <li>
                                            <h4>Total Payout</h4>
                                            <h4>₹{txnDetails?.winning_amount} <span style={{ color: '#38EF7D' }}>({(txnDetails?.winning_amount/txnDetails?.amount).toFixed(1)}X)</span></h4>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Reciept;